<app-alert type="warning"
           (closed)="cancel()">
  <ng-container alert-title>
    {{ 'constructor2.incomplete-alert.title' | translate }}
  </ng-container>
  <ng-container alert-body>
    <div *ngFor="let warning of warnings; trackBy: trackByFn">
      {{ warning | translate }}
    </div>
  </ng-container>
  <ng-container alert-buttons>
    <on-ui-button class="primary outline"
                  label="constructor2.incomplete-alert.later"
                  (onclick)="cancel()">
    </on-ui-button>
    <on-ui-button class="primary"
                  label="constructor2.incomplete-alert.edit"
                  (onclick)="submit()">
    </on-ui-button>
  </ng-container>
</app-alert>
